/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_filters__detailed_view__label = /** @type {(inputs: {}) => string} */ () => {
	return `Preise, Anzahl der Sterne ... anzeigen`
};

const en_poi_filters__detailed_view__label = /** @type {(inputs: {}) => string} */ () => {
	return `Display prices, star ratings...`
};

const es_poi_filters__detailed_view__label = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar precio, número de estrellas...`
};

const fr_poi_filters__detailed_view__label = /** @type {(inputs: {}) => string} */ () => {
	return `Afficher les prix, le nombre d’étoiles...`
};

const it_poi_filters__detailed_view__label = /** @type {(inputs: {}) => string} */ () => {
	return `Visualizza i prezzi, il numero di stelle...`
};

const nl_poi_filters__detailed_view__label = /** @type {(inputs: {}) => string} */ () => {
	return `Prijzen weergeven, aantal sterren...`
};

const pt_poi_filters__detailed_view__label = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar os preços, o número de estrelas...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__detailed_view__label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_filters__detailed_view__label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_filters__detailed_view__label", locale)
	if (locale === "de") return de_poi_filters__detailed_view__label(inputs)
	if (locale === "en") return en_poi_filters__detailed_view__label(inputs)
	if (locale === "es") return es_poi_filters__detailed_view__label(inputs)
	if (locale === "fr") return fr_poi_filters__detailed_view__label(inputs)
	if (locale === "it") return it_poi_filters__detailed_view__label(inputs)
	if (locale === "nl") return nl_poi_filters__detailed_view__label(inputs)
	return pt_poi_filters__detailed_view__label(inputs)
};